import React from 'react';
import MailIcon from '../../../icons/MailIcon';
import PropTypes from "prop-types";
import OutlineErrorIcon from "../../../icons/OutlineError.icon";
import WhatAppIcon from "../../../icons/WhatAppIcon";

export const ErrorMessageContent = (props) => {
  const inlineStyle = 'text-nowrap px-1 py-1 my-1';
  const inlineIcon = "inline-icon pr-1";
  const wrapRowStyle = 'd-flex flex-wrap justify-content-center';
  const iconColor = '#374151';

  const {message, email, phone, whatsapp, title, Icon = OutlineErrorIcon} = props;

  return (
    <div style={{ width: '480px', height: "auto", minHeight: '240px' }}>
      <div className="text-center"><Icon /></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center">{message}</p>
      <div style={{fontSize: '14px'}} className="pb-3">
        <div className={wrapRowStyle}>
          <span className={inlineStyle}>
            <span className={inlineIcon}>
              <MailIcon fontSize="small" fill='#fff' stroke={iconColor}/>
            </span>
            <a href={"mailto:" + email}>{email}</a>
          </span>
          {/*<span className="text-nowrap px-2 py-1 my-1">*/}
          {/*  <span className={inlineIcon}>*/}
          {/*    <PhoneIcon fontSize="small" fill={iconColor}/>*/}
          {/*  </span>*/}
          {/*  <span>{phone}</span>*/}
          {/*</span>*/}
          <span className={inlineStyle}>
            <span className={inlineIcon}>
              <WhatAppIcon fontSize="small" fill={iconColor}/>
            </span>
            <span>{whatsapp}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

ErrorMessageContent.defaultProps = {
  title: '¡Ha ocurrido un error!',
  message: 'Intente nuevamente o contáctenos.',
  email: 'soporte-idauto@dox.cl',
  phone: '+56 2 6543 8765',
  whatsapp: '+56 999846063',
};

ErrorMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  whatsapp: PropTypes.string,
};

export default React.memo(ErrorMessageContent);
